import {EventListeners, MinzeElement, Reactive} from "minze";
import {SearchBarSubscriber} from "../../modules/search/SearchBarSubscriber";
import {Routing} from "../../modules/routing";
import {Locale} from "../../modules/locale";
import { SquidexTextLabels } from "../../modules/squidex/labels";

export interface TjSearchBar {
  dataGroupId: string
  query: string
}

Locale.getInstance().registerKeySet("fr", "searchBar", {
  "placeholder": "Recherche",
  "youthsSuffix": "jeunes",
  "parentsSuffix": "parents",
});

Locale.getInstance().registerKeySet("en", "searchBar", {
  "placeholder": "Search",
  "youthsSuffix": "youths",
  "parentsSuffix": "parents",
});

export class TjSearchBar extends MinzeElement {
  attrs = ["data-group-id"];
  searchBarSubscriber: SearchBarSubscriber | null = null;
  initialSearchText: string = "";
  reactive: Reactive = [["query", ""]];
  lang = Locale.language;
  searchSuffixPairs: {[key: string]: string} = {
    "jeunes": SquidexTextLabels.getKey("searchBar.youthsSuffix"),
    "parents": SquidexTextLabels.getKey("searchBar.parentsSuffix")
  }

  async handleInput(event: Event) {
    // @ts-ignore
    this.query = event.target?.value
  }

  setQueryValue = (value: string) => {
    this.query = value;
    this.searchBarSubscriber?.doSearch(this.query);
  }

  search = () => {
    const mainModule = window.TJ_MAIN_MODULE;
    const routing = mainModule.getRouting();
    routing.goTo(
      `/${this.lang}${this.searchSuffixPairs[this.dataGroupId] ? `/${this.searchSuffixPairs[this.dataGroupId]}` : ''}` +
      `${Routing.ROUTES?.[this.lang].search}?query=${this.query}`
    );
  }


  onReady(): void | Promise<void> {
    this.searchBarSubscriber = new SearchBarSubscriber(
      this.dataGroupId as string || import.meta.env.VITE_ALGOLIA_INDEX_NAME,
      this.setQueryValue
    );
    const mainModule = window.TJ_MAIN_MODULE;
    const searchConfigsModule = window.TJ_SEARCH_CONFIGS;
    mainModule.getSearchManager().subscribe(this.searchBarSubscriber);
    if (!this.shadowRoot) return;
    const inputElement = this.shadowRoot.querySelector('input');
    inputElement?.addEventListener('input', this.handleInput.bind(this));
    this.initialSearchText = searchConfigsModule?.searchCoreConfigs?.[this.dataGroupId as string]?.defaultQuery || "";
    if (this.initialSearchText === "") return;
    this.rerender();
    this.searchBarSubscriber?.doSearch(this.initialSearchText);
  }

  html = () => /* html */ `
    <div class="search-bar">
      <input
        id="search-input"
        placeholder="${SquidexTextLabels.getKey("searchBar.placeholder")}"
        value="${this.query || this.initialSearchText}"
      />
      <tj-button
        width="64px"
        height="64px"
        padding="0"
        display="flex"
        justifyContent="center"
        alignItems="center"
        id="submit"
      >
        <tj-search-icon></tj-search-icon>
      </tj-button>
    </div>
  `;

  css = () => `
    tj-search-icon {
      width: 28px;
      height: 28px;
    }
    .search-bar {
      display: flex;
      justify-content: center;
      gap: 16px;
    }
    input {
      width: 100%;
      max-width: 600px;
      background: #FFFFFF;
      border-radius: 14px;
      padding: 17px 16px;
      border: none;
      font-family: inherit;
      font-weight: 400;
      font-size: 20px;
      line-height: 150%;
      color: #133762;
    }
    button {
      width: 64px;
      min-width: 64px;
      height: 64px;
      background: #068FC3;
      border-radius: 14px;
      padding: 0;
      border: 0;
      cursor: pointer;
    }
  `;

  eventListeners: EventListeners = [
    ["#submit", "click", this.search],
    ["#search-input", "keyup", (event: any) => {if (event?.keyCode === 13) {this.search()}}]
  ];
}
